<template>
  <div id="detail" class="detail">
    <div class="back" @click="back"><img src="./img/backup.png" alt=""><span>返回上一页</span></div>
    <h5>{{detailText.title}}</h5>
    <video
            v-if="attribute == 3"
            style="height:26vw"
            :src="src1"
            controls
            width="100%"
            ref="vueRef"
        ></video>
        <!-- <img style="width:100%" v-else :src="src1"> -->
    <p v-html="detailText.cnt" class="rich_text"></p>
  </div>
</template>
<script>
import util from '@/util/util.js'
import Axios from 'axios'
export default {
  props: ['id'],
  data () {
    return {
      attribute:'',
      src1:'',
      detailText: ''
    };
  },
  created(){
    this.detail();
  },
  methods: {
    detail(){
      Axios({
        params:{
          id:this.id
        },
        // util.config.api
        methods:'post',
        baseURL: util.config.api,
        url: '/1.0/news/news-info'
      }).then(res=>{
        console.log(res,'详情详情');
        this.detailText = res.data.obj;
        this.attribute = res.data.obj.attribute
        if(res.data.obj.attribute == 3) {
          this.src1 = res.data.obj.url
        }else {
          this.src1 = res.data.obj.pic
        }
       
      }).catch(error=>{
        console.log(error)
      })
    },
    back(){
      // console.log(89999998)
      this.$root.bus.$emit('back', false) 
    }
  }
}
</script>
<style scoped lang="scss">
  h5{
    font-size: 1.04166vw;
    font-weight: normal;
    margin-bottom: 1.04166vw;
  }
  .detail{
    .rich_text >>> img{
      width: 100%;
    }
    .back{
      cursor: pointer;
      margin-bottom: 1.04166vw;
      img{
        width: 1.145833vw;
        height: 0.98958333vw;
        vertical-align: middle;
        margin-right: .5vw;
      }
      span{
        font-size: .8333vw;
        color: #666;
        font-family:PingFang SC;
      }
    }
    
    
  }
</style>


// WEBPACK FOOTER //
// src/views/aboutus/aboutdetail.vue